export default __webpack_public_path__ + "static/media/hero-card.143dc4d1.png";